import { create } from 'zustand'
import { authFetch } from '../common/utils/cognito'
import { FeedType, TherapistFeed } from '../types/Feed'
import { Therapist } from '../types/Therapist'

type TherapistStore = {
  therapists: TherapistFeed[]
  fetch: () => Promise<void>
}

export const useTherapistStore = create<TherapistStore>((set) => ({
  therapists: [],
  fetch: async () => {
    const response = await authFetch(
      `${process.env.REACT_APP_API_URL}/therapists/active-list`,
    )

    if (response.ok) {
      const therapists = (await response.json()) as Therapist[]
      set({
        therapists: therapists.map((therapist) => ({
          id: therapist.id,
          type: FeedType.THERAPIST,
          content: therapist as Therapist,
        })),
      })
    } else {
      throw new Error(response.statusText)
    }
  },
}))
